const KEY_TOKEN = 'sabaidee_token';
const KEY_AUTH = 'sabaidee_auth';

export function getToken() {
  try {
    return localStorage.getItem(KEY_TOKEN) || '';
  } catch {
    return '';
  }
}

export function getAuth() {
  try {
    const raw = localStorage.getItem(KEY_AUTH);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function setAuth({ token, user, teams }) {
  try {
    if (token) localStorage.setItem(KEY_TOKEN, token);
    localStorage.setItem(KEY_AUTH, JSON.stringify({ user, teams: teams || [] }));
  } catch {
    /* ignore */
  }
}

export function clearAuth() {
  try {
    localStorage.removeItem(KEY_TOKEN);
    localStorage.removeItem(KEY_AUTH);
  } catch {
    /* ignore */
  }
}

/** Đọc payload JWT (không verify chữ ký — chỉ để lấy role hiển thị khi localStorage.user lệch). */
function jwtPayloadRole(token) {
  try {
    const parts = String(token || '').split('.');
    if (parts.length !== 3) return null;
    const b64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    const pad = b64.length % 4 ? '='.repeat(4 - (b64.length % 4)) : '';
    const json = JSON.parse(atob(b64 + pad));
    return json && json.role != null ? String(json.role).trim().toLowerCase() : null;
  } catch {
    return null;
  }
}

function normRole(value) {
  if (value == null) return '';
  const s = String(value).trim().toLowerCase();
  return s.replace(/\s+/g, '_');
}

export function isCompanyAdmin() {
  const a = getAuth();
  const fromStore = normRole(a?.user?.role);
  if (fromStore === 'company_admin') return true;
  const fromJwt = normRole(jwtPayloadRole(getToken()));
  return fromJwt === 'company_admin';
}
